export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://api.oreca.pro/api'
  : 'http://127.0.0.1:8000/api'
